import { render, staticRenderFns } from "./土地信息.vue?vue&type=template&id=fcc89a46&scoped=true"
import script from "./土地信息.vue?vue&type=script&lang=js"
export * from "./土地信息.vue?vue&type=script&lang=js"
import style0 from "./土地信息.vue?vue&type=style&index=0&id=fcc89a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc89a46",
  null
  
)

export default component.exports